module.exports = __webpack_public_path__ + "img/9.360a7b01.png";